import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202510: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202510",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-10-01",
  endDate: "2025-10-31",
  impressions: 15371,
  clicks: 246,
  adsSpendDollars: 1500,
  budgetDollars: 1500,
  salesDollars: 37280,
  bestEstimateRoas: 24.85,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 1,
  newCustomersAcquired: 17,
  dataAvailableAtDate: "2025-11-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
